import gql from 'graphql-tag'
import client from '@stores/apollo'

export default function updateClasic({ isClassic }: { isClassic: boolean }) {
  return client.gql.mutate({
    mutation,
    variables: { input: { isClassic } },
  })
}

const mutation = gql`
  mutation updateClasic($input: UpdateUserClassicModeMutationInput!) {
    updateUserClassicModeMutation(input: $input) {
      isClassic
    }
  }
`
